import { gql } from "@apollo/client";

export const initiatePaymentSchema = gql`
  mutation InitiatePayment($input: PaymentInput!) {
    initiatePayment(input: $input)
  }
`;

export const completePaymentSchema = gql`
  mutation CompletePayment($input: CompletePaymentInput!) {
    completePayment(input: $input)
  }
`;
